import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmDialogService } from '@serviceplan/ui-kit';
import { AssetUIModel, AssetsGenerateUrlService } from '@thehubz/client/core';
import { Subscription } from 'rxjs';
import { AssetCommonService } from '../../../services/asset-common.service';
import { AssetViewComponent } from '../asset-info/components/asset-view/asset-view.component';
import { AssetVersionCardComponent } from './asset-version-card/asset-version-card.component';

@Component({
  selector: 'thehubz-asset-versions',
  templateUrl: './asset-versions.component.html',
  styleUrls: ['./asset-versions.component.scss'],
  standalone: true,
  imports: [CommonModule, AssetVersionCardComponent, AssetViewComponent],
})
export class AssetVersionsComponent implements OnInit, OnDestroy {
  assetInfo!: AssetUIModel;
  versionPreviewURL = '';
  selectedVersion = '';
  assetDataSubjectSubscription?: Subscription;

  constructor(
    private assetCommonService: AssetCommonService,
    private confirmDialog: ConfirmDialogService,
    private assetsGenerateUrlService: AssetsGenerateUrlService,
  ) {}

  ngOnInit(): void {
    this.assetDataSubjectSubscription = this.assetCommonService.assetDataSubject$.subscribe((data) => {
      if (data) {
        this.assetInfo = data as AssetUIModel;
        const currentVersion = this.assetInfo.versions?.filter((ver) => ver.version === this.assetInfo.currentVersion?.version);
        const versionSorted = this.assetInfo.versions
          ?.filter((ver) => ver.version !== this.assetInfo.currentVersion?.version)
          .sort((a, b) => b.version - a.version);
        versionSorted?.unshift(...currentVersion);
        this.selectedVersion = `selected-${this.assetInfo.currentVersion?.version}`;
        this.assetInfo.versions = versionSorted;
      }
    });
  }

  async viewSelectedVersion(v: number) {
    this.assetInfo = this.assetsGenerateUrlService.addPreviewUrl(this.assetInfo, v);
    this.assetInfo.selectedVersion = v;
    this.selectedVersion = `selected-${v}`;
  }

  deleteAssetVersion(event: { assetId: string; versionId: string }) {
    this.confirmDialog
      .open({
        title: $localize`Delete confirmation`,
        message: $localize`Are you sure you want to delete this asset version?`,
      })
      .subscribe((confirm) => {
        if (confirm) {
          const currentVersion = this.assetInfo.currentVersion?.version || 1;
          this.viewSelectedVersion(currentVersion);
          this.assetCommonService.assetsRemoveAssetVersion(this.assetInfo, event.assetId, event.versionId);
        }
      });
  }

  ngOnDestroy(): void {
    this.assetDataSubjectSubscription?.unsubscribe();
  }
}
